// extracted by mini-css-extract-plugin
export default {"main":"styles__main___9lY0H"};